import { fieldRegEx, getAllMatches } from "./regex"

export default class EvaluationContextSync {
  constructor(engine, context) {
    this.__engine = engine
    this.__context = context
  }

  replaceVariables(exp) {
    const matches = getAllMatches(fieldRegEx, exp)
    const uniqueMatches = new Set()
    matches.every((el) => uniqueMatches.add(el[1]))

    let result = exp

    for (const variableName of Array.from(uniqueMatches)) {
      const variableValue = this.__engine.__getFieldValue(
        variableName,
        this.__context
      )

      result = result.replace(
        new RegExp(`\\{${variableName}\\}`, "g"),
        JSON.stringify(variableValue)
      )
    }

    return result
  }

  evaluate(exp) {
    if (exp === "") return true

    let functionCode

    try {
      const isSafe = this.__engine.isExpSafe(exp)
      if (!isSafe) {
        throw Error(`Expression "${exp}" is not safe.`)
      }

      const parsedExp = this.replaceVariables(this.__engine.replaceAliases(exp))

      functionCode = "const { formulas: fn } = this; return " + parsedExp
      // eslint-disable-next-line no-new-func
      const expFn = new Function(functionCode)

      const boundExpFn = expFn.bind({ formulas: this.__engine.__formulas })

      return boundExpFn()
    } catch (error) {
      console.log(
        `expression ${exp} failed: ${error.message}\nfunction code: ${functionCode}`
      )
      return "#ERROR"
    }
  }
}
